import type { SVGProps } from 'react';

interface CheckIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const CheckIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & CheckIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M10 .5c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10S4.477.5 10 .5m3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06"
      fill="currentColor"
    />
  </svg>
);
